export default "/assets/aa931cfcb4bd633e0d39dc78bc07d1d7.woff";